import { render } from "./BlogEntry.vue?vue&type=template&id=a65c6ede&scoped=true"
import script from "./BlogEntry.vue?vue&type=script&lang=js"
export * from "./BlogEntry.vue?vue&type=script&lang=js"

import "./BlogEntry.vue?vue&type=style&index=0&id=a65c6ede&scoped=true&lang=css"

import exportComponent from "C:\\Users\\khurr\\OneDrive\\desktop\\development\\refinedhealthpros\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a65c6ede"]])

export default __exports__